import { schema } from 'normalizr';

const activity = new schema.Entity('activities');

export default activity;

